import { Stack, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import { ContextModalProps } from '@mantine/modals'
import Form from 'common/Form'
import { useUpdateManufacturer } from 'hooks/products'
import { Manufacturer, UpdateManufacturer } from 'types/products'
import { manufacturerSchema } from 'types/schemas'
import { trimFormValues } from 'utils'

type Props = {
  manufacturer: Manufacturer
}

export default function UpdateManufacturerModal({
  context,
  id,
  innerProps: { manufacturer },
}: ContextModalProps<Props>) {
  const updateManufacturer = useUpdateManufacturer()

  const form = useForm<UpdateManufacturer>({
    validate: zodResolver(manufacturerSchema),
    initialValues: manufacturer,
    transformValues: trimFormValues,
  })

  return (
    <Form
      onSubmit={async (values) => await updateManufacturer.mutateAsync({ ...values, id: manufacturer.id })}
      form={form}
      onCancel={() => context.closeModal(id)}
      submitText="Zaktualizuj producenta"
    >
      <Stack gap="xs">
        <TextInput label="Nazwa producenta" placeholder="HAFT" withAsterisk {...form.getInputProps('name')} />
        <TextInput
          label="Email"
          description="Adres email na który wysyłane są zamówienia"
          placeholder="email@example.com"
          withAsterisk
          {...form.getInputProps('email')}
        />
      </Stack>
    </Form>
  )
}
